import { Head } from "@inertiajs/react"
import { Check, Home, Plus, Search } from "lucide-react"

import { HeroIcon } from "@/components/tuw/auth/AuthHeading"
import OnboardingLayout, { StepTitle } from "@/components/tuw/onboarding/OnboardingLayout"
import { Button } from "@/components/ui/button"

const CARD_CLASS =
  "flex flex-col gap-1.5 rounded-[14px] border border-border bg-card p-4 text-foreground no-underline transition-colors hover:border-ink-3"

// The welcome after onboarding (P11-H6): the profile is finished, so the
// customer is offered the two things worth doing first and the dashboard.
export default function Done({ email, initials, signOut, firstName = "", links }) {
  return (
    <OnboardingLayout step="done" email={email} initials={initials} signOut={signOut} narrow>
      <Head title="You’re all set · The Urban Writers" />

      <HeroIcon icon={Check} ok />

      <StepTitle title={firstName ? `You’re all set, ${firstName}` : "You’re all set"}>
        Your account is verified and ready. Posting a project is free. You only pay once a freelancer accepts.
      </StepTitle>

      <div className="grid grid-cols-2 gap-3 max-[560px]:grid-cols-1">
        <a href={links.post} className={CARD_CLASS}>
          <Plus className="size-5 text-primary" strokeWidth={1.9} aria-hidden="true" />
          <b className="font-display text-[14px] font-bold">Post your first project</b>
          <span className="text-[12.5px] leading-[1.45] text-ink-3">Pick a service and tell us what you need.</span>
        </a>
        <a href={links.freelancers} className={CARD_CLASS}>
          <Search className="size-5 text-primary" strokeWidth={1.9} aria-hidden="true" />
          <b className="font-display text-[14px] font-bold">Browse freelancers</b>
          <span className="text-[12.5px] leading-[1.45] text-ink-3">Writers, editors, designers and narrators.</span>
        </a>
      </div>

      <div className="pt-1.5">
        <Button asChild variant="ghost" className="h-auto rounded-[11px] px-4 py-3 text-[14px] font-semibold">
          <a href={links.dashboard}>
            <Home className="size-4" strokeWidth={2} aria-hidden="true" />
            Go to dashboard
          </a>
        </Button>
      </div>
    </OnboardingLayout>
  )
}
